import React from "react";
import { User } from "firebase/auth";
import { onAuthChange, isAdmin } from "../services/authService";

interface AuthContextValue {
  user: User | null;
  isAdminUser: boolean;
  loading: boolean;
}

const AuthContext = React.createContext<AuthContextValue>({
  user: null,
  isAdminUser: false,
  loading: true,
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = React.useState<User | null>(null);
  const [isAdminUser, setIsAdminUser] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsubscribe = onAuthChange(async (u) => {
      setUser(u);
      try {
        if (u) {
          const admin = await isAdmin(u);
          setIsAdminUser(admin);
        } else {
          setIsAdminUser(false);
        }
      } catch {
        setIsAdminUser(false);
      } finally {
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const value = React.useMemo(() => ({ user, isAdminUser, loading }), [user, isAdminUser, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => React.useContext(AuthContext);
